// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGClose = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#close__clip0_12_2672)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h32v32H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "close__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#close__clip1_12_2672)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M3.772 3.759c.445-.445 1.165-.445 1.61 0L16 14.389 26.617 3.77c.445-.446 1.165-.446 1.611 0 .446.446.446 1.166 0 1.611L17.611 16l.023-.013 10.618 10.618c.445.445.445 1.165 0 1.611-.229.217-.515.331-.812.332-.297 0-.583-.103-.811-.332L16.012 17.6 5.394 28.216c-.228.217-.514.331-.81.332-.298 0-.584-.103-.812-.332-.446-.446-.446-1.166 0-1.611l10.616-10.618L3.772 5.37c-.446-.446-.446-1.166 0-1.611z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#close__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "close__clip0_12_2672",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "close__clip1_12_2672",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGClose.displayName = 'SVGClose';
export default SVGClose;